import { gql } from "@apollo/client";

export const UPDATE_POINT_REDEMPTION_STATUS = gql`
  mutation UpdateGiftStatus($status: GiftStatus) {
    updateGiftStatus(status: $status)
  }
`;
